import React from 'react'
import MyPayroll from './MyPayroll'


export default function AlumniStudentReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
